import { Button, Flex, Modal, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

interface TrainingInformativeModalProps {
  storageKey: string;
  hasAction?: boolean;
}

export const TrainingInformativeModal = ({
  storageKey,
  hasAction = false,
}: TrainingInformativeModalProps) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(() => {
    const opened = sessionStorage.getItem(storageKey);
    return !opened;
  });

  const handleClose = () => {
    sessionStorage.setItem(storageKey, "true");
    setOpen(false);
  };

  const handleStart = () => {
    sessionStorage.setItem(storageKey, "true");
    setOpen(false);
    void navigate("/treinamentos");
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={
        hasAction ? (
          <Button type="primary" onClick={handleStart}>
            Iniciar
          </Button>
        ) : null
      }
      title={
        <Flex gap={8} align="center">
          <ExclamationCircleOutlined style={{ color: "#40A9FF" }} />
          <Typography.Text strong>Atenção!</Typography.Text>
        </Flex>
      }
    >
      <div style={{ marginTop: 24 }}>
        <Typography.Title level={4}>🚨 URGENTE! 🚨</Typography.Title>

        <Typography.Text strong style={{ fontSize: 16 }}>
          Treinamentos obrigatórios de COMPLIANCE já estão disponíveis ⚠️
        </Typography.Text>

        <div style={{ marginTop: 24 }}>
          <Typography.Text strong style={{ fontSize: 16 }}>
            ⏰ Prazo final: 17/04
          </Typography.Text>
        </div>
      </div>
    </Modal>
  );
};
